import $ from 'jquery';
import twitterFetcher from 'twitter-fetcher';

export default class DynamicTwitter {
  constructor(section) {
    this.el = section.el;
    this.$el = $(this.el);
    this.initializedClass = 'twitter-initialized';
    this.tweetContainer = $('[data-twitter-tweets]', this.el);

    const username = $('[data-twitter-username]', this.el).attr('data-twitter-username');
    const retweets = $('[data-show-retweets]', this.el).data('show-retweets');
    const isInitialized = this.$el.hasClass(this.initializedClass);

    if (!isInitialized) {
      this._fetchTweets(username, retweets);
    }
  }

  _fetchTweets(username, retweets) {
    const config = {
      profile: { screenName: username },
      maxTweets: 1,
      enableLinks: true,
      showUser: true,
      showTime: true,
      showRetweet: retweets,
      customCallback: tweets => this.renderTweets(tweets),
      showInteraction: false,
      useEmoji: true,
      showImages: true,
    };

    twitterFetcher.fetch(config);
  }

  renderTweets(tweets) {
    if (tweets.length) {
      for (let i = 0; i < tweets.length; i++) {
        const $tweet = $(tweets[i]);

        this.tweetContainer.append(`
          <div class='tweet-wrap'>
            ${$tweet[1].innerHTML}
            <span class='timestamp'>
              ${$tweet[2].innerHTML}
              <span class='divider'>/</span>
              ${$tweet[0].innerHTML}
            </span>
          </div>
        `);
      }

      this.$el.toggleClass(this.initializedClass, true);
    } else {
      // twitterFetcher changes the view element to window, so we cannot use @$el here
      this.tweetContainer.html('');
      console.log('No tweets to display. Most probable cause is an incorrectly entered username.');
    }
  }
}
